// extracted by mini-css-extract-plugin
module.exports = {"nav":"home_nav__3YOTM","productsSliderContainer":"home_productsSliderContainer__33Vj0","homeNavbar":"home_homeNavbar__1lWyN"};